import request from '@/utils/request'
const apiPath = '/cust_service/custServiceInfoLibrary'
import { downloadBlob } from '@/utils/download'
const custServiceInfoLibraryApi = {
  /**
   * 新增【知识库】
   */
  create(data) {
    return request.post(apiPath + '/tee/save', data)
  },
  /**
   * 修改【知识库】
   */
  update(data) {
    return request.put(apiPath + '/tee/update', data)
  },
  /**
   * 分页查询【知识库】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  fetchForList(query) {
    return request.get(apiPath + '/tee/listPageForMini', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【知识库】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【知识库】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '知识库.xlsx'))
  },
}
export default custServiceInfoLibraryApi
